export default {
  labels: {
    username: 'Username',
  },
  placeholders: {
    username: 'Enter your employee code',
  },
  buttons: {
    login: 'Log In',
    save: 'Save',
  },
  title: 'MAMC',
};
